import { GeneralModel } from "./general.model";
import { District } from "./district.model";
import { Ward } from "./ward.model";
import { Province } from "./province.model";
import { AreaC } from ".";

export class Hub extends GeneralModel {
    email: string;
    phoneNumber: string;
    address: string;
    addressDisplay: string;
    fax: string;
    lat: number;
    lng: number;
    radiusServe: number;
    provinceId: number;
    districtId: number;
    wardId: number;
    provinceIdNew: number;
    wardIdNew: number;
    areaId: number;
    centerHubId: number;
    poHubId: number;
    province: Province;
    district: District;
    ward: Ward;
    centerHub: Hub;
    poHub: Hub;
    areaC: AreaC;
    paymentUnitId: number;
    signUserId: number;
    isWareHouseInternal: boolean;
    IsAllowParentPickup: boolean;
    MergedWardName: string;
    MergedProvinceName: string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/hub.model.ts